import { render } from "./ModalRemoveCustomerGroup.vue?vue&type=template&id=00e07459"
import script from "./ModalRemoveCustomerGroup.vue?vue&type=script&lang=js"
export * from "./ModalRemoveCustomerGroup.vue?vue&type=script&lang=js"

import "./ModalRemoveCustomerGroup.vue?vue&type=style&index=0&id=00e07459&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__